/*
  Utility function to mimic django' logging behaviour.
  Based on the log level set by environment variable,
  console logs are muted accordingly.
  For example, if log level = warn, only console logs of
  levels warn and error are shown.
*/

// All available levels and their respective order
const LEVELS = {
  info: 1,
  debug: 2,
  log: 3,
  warn: 4,
  error: 5
}

const LOG_LEVEL = ((env) => {
  // Detects log level based on environment mode
  switch (env) {
    case 'development':
      return 'info'
    case 'test':
      return 'log'
    default:
      return 'warn'
  }
})(import.meta.env.MODE)

console.log(`[TA] Log level set to "${LOG_LEVEL}"`)

const namedLogger = (namespace, level, ...args) => {
  // builds a particular logger and prefixes all messages with a namespace
  if (LEVELS[level] >= LEVELS[LOG_LEVEL]) {
    return console[level](`[${namespace}]`, ...args)
  } else { // if muted, return empty function
    return () => {}
  }
}

interface Logger {
  info: (...args: any[]) => void
  debug: (...args: any[]) => void
  log: (...args: any[]) => void
  warn: (...args: any[]) => void
  error: (...args: any[]) => void
  [key: string]: (...args: any[]) => void
}

const logger = (namespace: string): Logger => {
  // builds the logger
  const logs = {} as Logger
  for (const level in LEVELS) {
    if (Object.prototype.hasOwnProperty.call(LEVELS, level)) {
      logs[level] = (...args) => namedLogger(namespace, level, ...args)
    }
  }
  return logs
}

export default logger
